import React from 'react';
import { IconProps } from '.';

const SvgColoredFaceNeutral = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FFCC4D'
        d='M23 12c0 6.075-4.925 11-11 11-6.074 0-11-4.925-11-11C1 5.926 5.926 1 12 1c6.075 0 11 4.926 11 11Z'
      />
      <path
        fill='#664500'
        d='M8.028 12.306c.844 0 1.528-.958 1.528-2.14 0-1.18-.684-2.138-1.528-2.138S6.5 8.985 6.5 10.167c0 1.181.684 2.139 1.528 2.139ZM15.972 12.306c.844 0 1.528-.958 1.528-2.14 0-1.18-.684-2.138-1.528-2.138s-1.528.957-1.528 2.139c0 1.181.684 2.139 1.528 2.139ZM16.278 16.889H7.722a.611.611 0 1 1 0-1.222h8.556a.61.61 0 1 1 0 1.222Z'
      />
    </svg>
  );
};

export default SvgColoredFaceNeutral;
